import React, { Component } from 'react';
import queryString from 'querystring';

// 계정 삭제 안내 페이지 — Google Play(데이터 안전 > 계정 삭제 URL) / App Store 심사용.
// 앱 내 자체 삭제 기능이 아직 없어 이메일 요청 방식으로 안내한다.
// ?lang=en | ja | (기본 ko). 약관/개인정보 페이지와 동일한 share-container 스타일.
const CONTACT_EMAIL = 'atozsoft@atozsoft.co.kr';
const SUBJECT = { ko: '[HALASZ] 계정 삭제 요청', en: '[HALASZ] Account deletion request', ja: '[HALASZ] アカウント削除リクエスト' };

const TEXT = {
  ko: {
    title: 'HALASZ 계정 삭제 안내',
    intro: 'HALASZ(할라스) 앱 계정과 관련 데이터의 삭제를 원하시면 아래 절차에 따라 요청해 주세요.',
    howTitle: '1. 삭제 요청 방법',
    how: [
      '앱에 가입한 이메일 주소로 아래 주소에 메일을 보내 주세요.',
      '메일 본문에 가입 이메일(또는 사용자 이름)과 "계정 삭제 요청"을 적어 주세요.',
      '본인 확인 후 7일 이내에 삭제를 완료하고 회신 드립니다.',
    ],
    mailTo: '요청 메일 주소',
    subject: '메일 제목(권장)',
    dataTitle: '2. 삭제되는 데이터',
    data: ['계정 정보(이메일, 사용자 이름, 프로필 사진, 국가/시간대 설정)', '등록한 조황(사진, 어종, 길이, 위치, 메모)', '팔로우/팔로워, 차단 목록, 클랜 가입 정보', '알림(푸시) 등록 정보'],
    keepTitle: '3. 보관되는 데이터',
    keep: [
      '관계 법령에 따라 보존이 필요한 기록은 개인정보 처리방침에 명시된 기간 동안 보관 후 파기합니다.',
      '대회(토너먼트) 결과 등 다른 회원과 공유된 기록은 개인 식별 정보를 제거한 상태로 남을 수 있습니다.',
    ],
    note: '삭제된 계정과 데이터는 복구할 수 없습니다.',
    links: '관련 문서',
  },
  en: {
    title: 'HALASZ Account Deletion',
    intro: 'To delete your HALASZ account and associated data, please follow the steps below.',
    howTitle: '1. How to request deletion',
    how: [
      'Send an email to the address below from the email address registered to your account.',
      'Include your registered email (or username) and the words "account deletion request".',
      'After verifying your identity, we delete the account within 7 days and confirm by email.',
    ],
    mailTo: 'Request email',
    subject: 'Suggested subject',
    dataTitle: '2. Data that will be deleted',
    data: ['Account information (email, username, profile photo, country/timezone)', 'Your catches (photos, species, length, location, notes)', 'Follows/followers, block list, clan membership', 'Push notification registration'],
    keepTitle: '3. Data that may be retained',
    keep: [
      'Records that must be kept under applicable law are retained for the period stated in the Privacy Policy, then destroyed.',
      'Records shared with other members, such as tournament results, may remain with personal identifiers removed.',
    ],
    note: 'Deleted accounts and data cannot be recovered.',
    links: 'Related documents',
  },
  ja: {
    title: 'HALASZ アカウント削除のご案内',
    intro: 'HALASZ アプリのアカウントおよび関連データの削除をご希望の場合は、以下の手順でご依頼ください。',
    howTitle: '1. 削除依頼の方法',
    how: [
      'アカウントに登録したメールアドレスから、下記アドレス宛にメールをお送りください。',
      '本文に登録メールアドレス(またはユーザー名)と「アカウント削除希望」とご記入ください。',
      '本人確認後、7日以内に削除を完了し、メールでご連絡します。',
    ],
    mailTo: '依頼先メールアドレス',
    subject: '件名(推奨)',
    dataTitle: '2. 削除されるデータ',
    data: ['アカウント情報(メール、ユーザー名、プロフィール写真、国/タイムゾーン)', '登録した釣果(写真、魚種、サイズ、位置、メモ)', 'フォロー/フォロワー、ブロックリスト、クラン加入情報', 'プッシュ通知の登録情報'],
    keepTitle: '3. 保管されるデータ',
    keep: [
      '法令により保存が必要な記録は、プライバシーポリシーに記載の期間保管した後に破棄します。',
      '大会結果など他の会員と共有された記録は、個人を特定できる情報を除いた状態で残る場合があります。',
    ],
    note: '削除したアカウントとデータは復元できません。',
    links: '関連文書',
  },
};

class AccountDeletePage extends Component {
  constructor(props) {
    super(props);
    const param = queryString.parse((this.props.location.search || '').replace('?', ''));
    const raw = param.lang === 'jp' ? 'ja' : param.lang;
    this.state = { lang: TEXT[raw] ? raw : 'ko' };
  }

  render() {
    const t = TEXT[this.state.lang];
    const langQuery = this.state.lang === 'ko' ? '' : `?lang=${this.state.lang}`;
    const mailHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(SUBJECT[this.state.lang])}`;
    return (
      <div className="share-container">
        <div className={'tit_policy'}>{t.title}</div>
        {t.intro}
        <div className={'tit_subject'}>{t.howTitle}</div>
        <ol>
          {t.how.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ol>
        <p>
          <b>{t.mailTo}:</b> <a href={mailHref}>{CONTACT_EMAIL}</a>
          <br />
          <b>{t.subject}:</b> {SUBJECT[this.state.lang]}
        </p>
        <div className={'tit_subject'}>{t.dataTitle}</div>
        <ul>
          {t.data.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ul>
        <div className={'tit_subject'}>{t.keepTitle}</div>
        <ul>
          {t.keep.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ul>
        <p>
          <b>{t.note}</b>
        </p>
        <p>
          {t.links}: <a href={`/privacy${langQuery}`}>Privacy Policy</a> · <a href={`/terms${langQuery}`}>Terms of Service</a>
        </p>
      </div>
    );
  }
}

export default AccountDeletePage;
